module.exports = __webpack_public_path__ + "img/sideHole.df81ff84.svg";